import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "SectionItem" }
const _hoisted_2 = { class: "Title" }
const _hoisted_3 = {
  key: 0,
  class: "Subtitle"
}
const _hoisted_4 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    _createElementVNode("h5", _hoisted_2, _toDisplayString(_ctx.content.title), 1 /* TEXT */),
    (_ctx.content.subtitle)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.content.subtitle), 1 /* TEXT */))
      : _createCommentVNode("v-if", true),
    _createElementVNode("p", {
      innerHTML: _ctx.content.description,
      class: "Description"
    }, null, 8 /* PROPS */, _hoisted_4)
  ]))
}